/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';

type Props = {
  className?: string;
  title?: string;
};

// Brand logo mark — the circled "E" glyph shown next to the ERE-Vergelijk
// wordmark in the header and footer. Purely decorative branding.
export const LogoMark: React.FC<Props> = ({ className, title }) => (
  <svg
    viewBox="0 0 48 48"
    className={className}
    role={title ? 'img' : 'presentation'}
    aria-label={title}
    aria-hidden={title ? undefined : true}
  >
    <circle cx="24" cy="24" r="20" fill="none" stroke="currentColor" strokeWidth="2.5" />
    <g fill="currentColor">
      <rect x="13" y="12" width="6" height="24" rx="3" />
      <rect x="13" y="12" width="22" height="6" rx="3" />
      <rect x="13" y="21" width="10" height="6" rx="3" />
      <rect x="13" y="30" width="22" height="6" rx="3" />
    </g>
  </svg>
);
